/* eslint-disable */
import React from 'react';
import ReactCodeInput from 'react-verification-code-input';

interface CodeInputProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
  inputRef?: React.Ref<ReactCodeInput>;
}

const CODE_INPUT_STYLES = `
  .styles_react-code-input__CRulA > input {
    border-right: none !important;
    border-left: none;
    border-top: none;
    margin-right: 10px;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    font-family: "VWHeadWeb";
    font-weight: 300;
    color: #3C484d;
    font-size: 32px;
    border-bottom: solid 1px #dfe4e8;
    width: 4vw !important;
  }
  .styles_react-code-input__CRulA > input:focus {
    border: none;
    border-bottom: solid 1px #001e50;
    caret-color: black;
  }
  .styles_react-code-input-container__tpiKG {
    width: fit-content !important;
  }
  .c-link__effect:focus {
    outline: none;
    color: #0040c5;
  }
  @media (max-width: 959px) {
    .styles_react-code-input__CRulA > input {
      width: 10vw !important;
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  .send_me_code {
    margin-right: 3px;
    font-size: 12px;
  }
`;

const CodeInput: React.FC<CodeInputProps> = ({ value, onChange, disabled = false, inputRef }) => (
  <>
    <div className="u-mv" data-testid="mfa-code-input">
      <ReactCodeInput
        autoFocus
        fields={6}
        values={value.split('')}
        onChange={onChange}
        disabled={disabled}
        ref={inputRef}
      />
    </div>
    <style>{CODE_INPUT_STYLES}</style>
  </>
);

export default CodeInput;
